import { CreateProfileForm } from './CreateProfileForm';

export default CreateProfileForm;
